import React, { useState, useEffect } from "react";
import { useModal } from "../../../../Components/Modal";
import Workspace from "../../../../APIController/Workspace";
import Text from "../../../../Components/Text";
import TimeTrackingReport from "../../../../Components/TimeTrackingReport";
import CrudPage from "../../../../Components/CrudPage";

function TimeTrackingReportManagement() {
    /* API Controller */
    const { fetchUserFromWorkspace } = Workspace()

    const [workspaceUser, setWorkspaceUser] = useState([])
    //on startup
    useEffect(() => {
        fetchUserData()
    }, [])

    const roleLabel = (user, roleName) => {
        if (user.role === "ADMIN" || roleName === "ADMIN") return "Software Administrator"
        if (roleName === "OWNER") return "Eigentümer"
        if (roleName === "MANAGER") return "Manager"
        if (roleName === "EMPLOYEE") return "Mitarbeiter"
    }

    /* Set user */
    const fetchUserData = async () => {
        const data = await fetchUserFromWorkspace()
        setWorkspaceUser(data)
    }

    /* Handler */
    const handleViewReport = async (e, user) => {
        e.preventDefault()
        openModal(<TimeTrackingReport user={user} />)
    }

    /* Modal helper */
    const { ModalView, openModal } = useModal()

    const MainView = () => (
        <>
            <CrudPage
                title={"Mitarbeiter"}
                items={workspaceUser}
                crudActions={[
                    { type: "edit", color: "black", action: handleViewReport, icon: "report" }]}
                displayMethod={(user) => (
                    <>
                        <div className="flex flex-row gap-2 flex-1">
                            <Text type="itemmain">{user.firstName}</Text>
                            <Text type="itemmain">{user.lastName}</Text>
                        </div>
                        <Text type="itemmain">{user.email}</Text>
                        <Text type="itemtext">{`${roleLabel(user, user.workspace[0].role)}`}</Text>
                        <Text type="itemtext">{`Mitarbeiter PIN ${user.workspace[0].numberCode}`}</Text>
                    </>
                )}
                allowedTarget={"employeesCount"}
                currentTargetValue={workspaceUser.length}
            />
            <ModalView classNames="w-auto" />
        </>
    )


    return (MainView())
}
export default TimeTrackingReportManagement